import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import PhoneImage from 'images/ai-studio/ai_receptionist_phone.png';
import { heroFeatures } from '../constants/ai-studio-constants';
import FeatureItem from './FeatureItem';

const InformationBottomSection = () => {
    const { i18next } = useAppContext();
    return (
        <div className="bg-main mt-8 grid gap-8 rounded-2xl max-md:grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
            <div className="flex items-end justify-center px-8 pt-8 pb-0">
                <img
                    src={PhoneImage}
                    alt={i18next.t('ai-studio.features.phone_alt')}
                    className="w-full max-w-[280px] max-md:max-w-[220px]"
                />
            </div>

            <div className="px-8 pt-4 pb-10 md:px-12 md:py-16">
                <h2 className="mb-8 text-2xl text-white">
                    {i18next.t('ai-studio.features.title')}
                </h2>

                <div className="flex flex-col gap-6">
                    {heroFeatures.map((feature) => (
                        <FeatureItem
                            key={feature.titleKey}
                            title={i18next.t(feature.titleKey)}
                            description={i18next.t(feature.descKey)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InformationBottomSection;
